
    <div class="relative">
        <corp-control-title [corp-title]="corpLabel" [corp-size]="corpSize" [corp-disabled]="disabled"></corp-control-title>

        @if (isForm) {
<select
    class="corp-control cursor-pointer"
    [ngClass]="[
                        'corp-control-' + corpSize,
                        (ngControl?.invalid && (ngControl?.touched || ngControl?.dirty)) ? 'border-red-500' : ''
                    ]"
    [disabled]="disabled || !!corpReadonly"
    [ngModel]="value"
    (ngModelChange)="onChange($event)"
    [compareWith]="compareWith"
    (blur)="onBlur($event)"
  >

    @for (opt of options; track opt.id) {
        <option [ngValue]="opt">
            {{ opt.label }}
        </option>
    }

  </select>




            
        } @else {

        }
        
    </div>